import React, { useEffect, useState } from "react";
import styles from "../../styles/dashboard/governance.module.css";
import DashboardCard from "../Common/DashboardCard";
import { get } from "../../utils/api";
import { useUser } from "../../context/AuthContext";
import useAuthStore from "../../store/ContextUser";

const Governance = ({ currentYear }) => {
  const { user } = useUser();
  const { selectedCompany } = useAuthStore();
  const [dashboardData, setDashboardData] = useState({
    boarddiversity: null,
    boardIndependent: null,
    ceopay: null,
    compliance: null,
    cyberIncidents: null,
  });

  const apiurls = {
    dashboard: `/dashboard/governance/overview?baseYear=${
      currentYear ? "baseline" : null
    }&companyId=${selectedCompany?._id}`,
  };

  const fetchData = async () => {
    try {
      const [dashboard] = await Promise.all([get(apiurls.dashboard)]);
      setDashboardData({
        boarddiversity: dashboard?.data?.boardDivesity,
        boardIndependent: dashboard?.data?.boardIndependRate,
        ceopay: dashboard?.data?.ceoPayRatio,
        compliance: dashboard?.data?.complainAndEthics,
        cyberIncidents: dashboard?.data?.cyberSecurity,
      });
    } catch (error) {
      console.log("first34", error);
    }
  };

  console.log("dash---->>>>>>>>>", dashboardData);

  useEffect(() => {
    fetchData();
  }, [currentYear, selectedCompany]);

  return (
    <>
      <div className={styles.main_container}>
        <div className={styles.cards_one}>
          <DashboardCard
            title="Board Independence Rate"
            subHeading="Percentage of board members who are independent."
            value={
              (currentYear
                ? dashboardData?.boardIndependent?.turnOverRate
                : dashboardData?.boardIndependent?.ratio) ?? 0
            }
            {...(currentYear
              ? {}
              : {
                  changeValue: `${Number(
                    dashboardData?.boardIndependent?.percentage ?? 0
                  ).toFixed(2)} YOY`,
                  change:
                    parseInt(dashboardData?.boardIndependent?.percentage) > 0
                      ? "increase"
                      : "decrease",
                })}
          />

          <DashboardCard
            title="CEO Pay Ratio"
            subHeading="Ratio of CEO compensation to median employee compensation."
            value={dashboardData?.ceopay?.ratio ?? "0:0"}
            {...(currentYear
              ? {}
              : {
                  changeValue: `${Number(
                    dashboardData?.ceopay?.percentage ?? 0
                  ).toFixed(2)} YOY`,
                  change:
                    parseInt(dashboardData?.ceopay?.percentage ?? 0) > 0
                      ? "increase"
                      : "decrease",
                })}
          />

          <DashboardCard
            title="Cybersecurity Incidents"
            subHeading="Number and severity of cybersecurity breaches."
            value={dashboardData?.cyberIncidents?.value ?? "0"}
            {...(currentYear
              ? {}
              : {
                  changeValue: `${Number(
                    dashboardData?.cyberIncidents?.percentage ?? "0"
                  ).toFixed(2)}% YOY`,
                  change:
                    parseInt(dashboardData?.cyberIncidents?.percentage, 10) > 0
                      ? "increase"
                      : "decrease",
                })}
          />
        </div>
        <div className={styles.cards_two}>
          <div className={styles.cards_two_inner}>
            <p className={styles.card_heading}>Board Diversity</p>
            <p className={styles.card_sub_heading}>
              Percentage of diverse members on the board of directors.
            </p>
            <div className={styles.table_div}>
              <div style={{ width: "50%" }}>
                <p className={styles.card_sub_heading}>Women</p>
                <p className={styles.card_value_reported}>
                  {dashboardData?.boarddiversity?.femaleBoardMembers || 0}%
                </p>
              </div>
              <div style={{ width: "50%" }}>
                <p className={styles.card_sub_heading}>Minorities</p>
                <p className={styles.card_value_resolved}>
                  {dashboardData?.boarddiversity?.minorityGroupBoardMembers ||
                    0}
                  %
                </p>
              </div>
            </div>
          </div>

          <DashboardCard
            title="Compliance and Ethics"
            subHeading="Number of Code of Conduct Violations."
            value={dashboardData?.compliance?.value ?? "0"}
            {...(currentYear
              ? {}
              : {
                  changeValue: `${Number(
                    dashboardData?.compliance?.percentage ?? 0
                  ).toFixed(2)}% YOY`,
                  change:
                    parseInt(dashboardData?.compliance?.percentage, 10) > 0
                      ? "increase"
                      : "decrease",
                })}
            subHeading1="Anti-Corruption Incidents"
            subvalue={dashboardData?.compliance?.antiCorruption ?? "0"}
          />
        </div>
      </div>
    </>
  );
};

export default Governance;
